import React from "react";
import {connect} from "react-redux";
import {Button} from "react-bootstrap";
import {hashHistory} from "react-router";
import * as authActions from "../redux/actions/Authentication/authActions";
import Logincont from "../react/pages/loginpage";

class Appcontainer extends React.Component {
  constructor() {
    super();
    this.state = {loading: false};
    this.logout = this.logout.bind(this);
    this.storeNewLogin = this.storeNewLogin.bind(this);
    this.redirect = this.redirect.bind(this);

  }

  logout() {
    window.location.href = ("https://accounts.quikr.com");
  }

  redirect() {
    location.reload();
  }

  storeNewLogin(login, error) {
    this.setState({loading: true});

    const load = (()=> {
      this.setState({loading: false});
    });

    this.props.authLogin(login, error, load);
  }

  componentDidMount() {
    // if(this.props.users.redirectToFeedback){
    //   hashHistory.push('/1/feedback');
    // }
    // else 
    if (this.props.auth[0].loggedIn) {
      hashHistory.push('/1/home');
    }
  }

  render() {
    const auth = this.props.auth;
    if (1) {
      return (
        <div id="login-wrapper">
          <nav className="navbar navbar-default">
            <div className="navbar-header">
              <a className="navbar-brand" href="#"><img src="/public/images/logo.png" alt="Quikr - Asaan hai Badalna"
                                                        width={94} height={43}/></a></div>
          </nav>
          <section className="home-login-banner">
            <div id="login" className="login-inner-wrap">
              <h1>You are still logged into SSO:</h1>
              <Button style={{marginRight: '50px'}} onClick={this.redirect} type="button">Click to Login again</Button>


              <Button onClick={this.logout} type="button">Logout from SSO</Button>

            </div>
          </section>


          <footer className="text-center home-footer">
            <div className="container">
              <div className="row">
                <div className="col-xs-12">
                  <p>2015 © Quikr India Private Limited.</p>
                </div>
              </div>
            </div>
          </footer>
        </div>);
    }
    return ( <div id="login-wrapper">

      <nav className="navbar navbar-default">
        <div className="navbar-header">
          <a className="navbar-brand" href="#"><img src="/public/images/logo.png" alt="Quikr - Asaan hai Badalna"
                                                    width={94} height={43}/></a>
        </div>
      </nav>
      <section className="home-login-banner">
        <div id="login" className="login-inner-wrap">
          <Logincont store={this.storeNewLogin} loading={this.state.loading}/>
        </div>
      </section>


      <footer className="text-center home-footer">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <p>2016 © Quikr India Private Limited.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>);
  }

}

Appcontainer.propTypes = {
  auth: React.PropTypes.array,
  authLogin: React.PropTypes.func.isRequired,
  authLogout: React.PropTypes.func.isRequired


};

function mapStateToProps(state, ownState) {
  //debugger;
  return {
    users: state.emp,
    auth: state.auth
  };


}
function mapDispatchToProps(dispatch) {
  return {
    authLogin: (login, error, load) => dispatch(authActions.login(login, error, load)),
    authLogout: () => dispatch(authActions.logOut())
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(Appcontainer);





/** WEBPACK FOOTER **
 ** ./src/containers/LoginPage.js
 **/